import React from "react";
import { cn } from "@/lib/utils";

/**
 * Circular progress ring — used on Student Dashboard.
 * Uses currentColor via CSS variables so it respects the active theme.
 */
export default function ProgressRing({
  value = 0,
  label,
  sublabel,
  size = 140,
  stroke = 10,
  color = "hsl(var(--primary))",
  trackColor = "hsl(var(--muted))",
  testId,
}) {
  const v = Math.max(0, Math.min(100, value));
  const r = 50 - stroke / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (v / 100) * c;
  return (
    <div className="flex flex-col items-center gap-3" data-testid={testId}>
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} viewBox="0 0 100 100" className="-rotate-90">
          <circle cx="50" cy="50" r={r} fill="none" stroke={trackColor} strokeWidth={stroke} />
          <circle
            cx="50" cy="50" r={r} fill="none"
            stroke={color} strokeWidth={stroke}
            strokeDasharray={c}
            strokeDashoffset={offset}
            strokeLinecap="round"
            style={{ transition: "stroke-dashoffset 900ms cubic-bezier(0.16, 1, 0.3, 1)" }}
          />
        </svg>
        <div className={cn("absolute inset-0 flex flex-col items-center justify-center leading-none")}>
          <div className="text-3xl font-bold tracking-tight">{Math.round(v)}%</div>
          {sublabel && <div className="text-[0.65rem] tracking-widest uppercase text-muted-foreground mt-1">{sublabel}</div>}
        </div>
      </div>
      {label && <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground text-center">{label}</div>}
    </div>
  );
}
